import axios from '@/services/httpService'

const fetchUsers = (ctx = { currentPage: 1, perPage: 5 }, filter) => {
  const config = {
    params: {
      employeeId: filter.employee,
      page: ctx.currentPage - 1,
      size: ctx.perPage
    }
  }

  const month = filter.month
  const year = filter.year
  return axios
    .get(`api/rendicontazione/lunch-ticket/${month}/${year}`, config)
    .then(res => res.data)
    .catch(err => console.log(err))
};

const save = (year, month, userId, report, editedDates) => {
  editedDates.sort()
  const reportToSend = editedDates.map(idx => ({ day: parseInt(idx) + 1, month: month, year: year, lunchTicket: report[idx] }))
  const payload = {
    user: { id: userId },
    lunchTicket: reportToSend
  }

  return axios
    .post(`api/rendicontazione/lunch-ticket/${month}/${year}`, payload)
    .catch(err => console.log(err))
}

export default {
  fetchUsers,
  save
};
